import { useTranslation } from "@coworker/locales";
import {
  formatLocationFilter,
  formatPeriodFilter,
} from "@coworker/apprestructured/src/task-management/util";

export type FieldFormat =
  | "location-filter"
  | "location-filter-with-in"
  | "period-filter";

/**
 * Returns a formatter function that translates raw filter codes stored in task
 * details (e.g. "depts=01", "period=7days") into localised display strings.
 * When no format is specified the value is returned as-is.
 *
 * Using a hook keeps the translation context out of individual fragments so
 * they remain generic and reusable across task types.
 */
export function useFormatFieldValue() {
  const { t } = useTranslation();

  return (value: string, format?: FieldFormat): string => {
    switch (format) {
      case "location-filter":
        return formatLocationFilter(value, t);
      case "location-filter-with-in":
        return t("mfaqInLocationString", {
          location: formatLocationFilter(value, t),
        });
      case "period-filter":
        return formatPeriodFilter(value, t);
      default:
        return value;
    }
  };
}
